import React from 'react'
import { connect } from 'react-redux'
import Home from '../components/home';
import {fetchLatestCuppings, fetchUserTables} from '../actions/actions'
import DisplayError from '../components/DisplayError';
import {CatoroSpinner} from '../components/CatoroSpinner'

class HomeContainer extends React.Component {

    componentDidMount(){
        window.scrollTo(0, 0);
        document.title = "Catoro☕️"
        this.props.fetchLatestCuppings()
        this.counter = 0
    }

    componentDidUpdate(prevProps) {
        if (this.props.latestCuppings !== prevProps.latestCuppings && this.props.user !== prevProps.user) {
            window.scrollTo(0, 0);
            this.props.fetchLatestCuppings()
        }
        else if  (this.props.user !== prevProps.user) {
            window.scrollTo(0, 0);
        }
      }

    fetchThisUserTables = () => {
        if (this.counter === 0) {
            this.props.fetchUserTables(this.props.user.id) 
            this.counter++
        }
      }

    render(){
        if (!!this.props.error) {
            // console.log(this.props.error_msg)
            return <DisplayError errorMsg={this.props.error_msg} />
        } else if (!this.props.latestCuppings) {
            return <CatoroSpinner/>
        } else if (this.props.isLoggedIn && this.props.user) {
            this.fetchThisUserTables(this.props.user.id) //runs once in component lifecycle due to counter.
            return   <Home name={this.props.user.name} id={this.props.user.id} latestCuppings={this.props.latestCuppings} isLoggedIn={this.props.isLoggedIn} userTables={this.props.userTables} userId={this.props.user.id}/>
        } else {
            return <Home latestCuppings={this.props.latestCuppings} isLoggedIn={this.props.isLoggedIn}/>
        }
    } 
}

const msp = state => {
	return {
      isLoggedIn: state.users.isLoggedIn,
      isLoggedOut: state.users.isLoggedOut,
      user: state.users.user,
      userTables: state.users.userTables,
      latestCuppings: state.cuppings.latestCuppings,
      error: state.users.error,
      error_msg: state.users.error_msg,
	}
  };
  
  export default connect(msp,{fetchLatestCuppings, fetchUserTables})(HomeContainer)